<template>
  <div class="mask" v-if="show">
    <div class="wrapper">
      <div class="headline">
        <div class="filter">
          <p class="title">{{`添加${$_syscfg.report}`}}</p>
          <div class="selectInputer">
            <div class="keyword">
              <span @click="toggleOption()">{{selected.title}}</span>
              <div v-if="expand" class="selects">
                <span v-for="(o, i) in options" :key="i" class="option" @click="selectOption(o)">
                  {{o.title}}
                </span>
              </div>
            </div>
            <img :src="expand ? icons.up : icons.down" alt="direct" class="direct" @click="toggleOption()">
            <input class="enter" type="text" :placeholder="`请输入要查找的${selected.title}`" v-model="search.word" @keyup.enter="searchByWord()">
            <img src="../assets/img/interview/search.svg" alt="search" class="search" @click="searchByWord()">
          </div>
        </div>
        <img src="../assets/img/interview/close.svg" alt="close" class="close" @click="close()">
      </div>
      <div class="container" ref="container">
        <empty :msg="`暂无${_syscfg.report}数据`" v-if="list && list.length === 0" />
        <div :class="{content: true}" v-for="(l, i) in list" :key="i">
          <div class="item">
            <img :src="l.id === selectedItem.id ? icons.checkerOn: icons.checker" alt="icon" @click="selectItem(l)">
            <p class="img">
              <img :src="l.cover || defaultImg" alt="" class="pic">
            </p>
            <div class="detail">
              <span class="title" @click="goReport(l.id)">
                {{l.title}}
              </span>
              <p class="text">
                {{l.info}}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="footline">
        <div class="btn" @click="confirm()">
          关联
        </div>
        <div class="btn gray" @click="close()">
          取消
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import { apis } from '@common/config'
import empty from '@components/empty'

export default {
  name: 'withClue',
  components: {
    empty
  },
  data() {
    return {
      show: false,
      icons: {
        up: require('@assets/img/interview/up.svg'),
        down: require('@assets/img/interview/down.svg'),
        checker: require('@assets/img/interview/checker.svg'),
        checkerOn: require('@assets/img/interview/checkerOn.svg'),
      },
      defaultImg: require('@assets/img/common/default.png'),
      options: [],
      search: {
        key: '',
        word: ''
      },
      list: null,
      selected: {},
      selectedItem: [],
      expand: false,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: null
      },
      scrollLock: false,
      // withs: [],
      isXnew: this.$store.state.isXnew,
    }
  },
  methods: {
    toggleOption() {
      this.expand = !this.expand
    },
    selectOption(o) {
      this.selected = o
      this.search.key = o.key
      this.expand = false
    },
    close() {
      this.show = false
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: null
      }
      this.list = null
    },
    open(report) {
      this.show = true
      this.$nextTick(() => {
        // this.withs = report
        // clues.forEach(i => {
        //   i.title = i.material_title || i.title
        //   i.cover = i.material_img || i.cover
        //   i.content = i.material_content || i.content
        //   i.info = i.material_content || i.content
        // })
        // this.list = clues.concat(this.list)
        this.selectedItem = report
        // this.list.forEach(j => {
        //   this.$set(j, 'selected', true)
        // })

        this.getList()
        this.handleScroll()
      })
    },
    getList() {
      this.scrollLock = true
      if (this.page.totalPage && this.page.pageIndex > this.page.totalPage) return

      const info = {
        search_option: this.search.key,
        key_words: this.search.word,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        // mid: this.withs.map(i => i.material_id).join(',')
      }

      common.myFetch(apis.publish_withReport, info)
        .then((data) => {
          this.page.pageIndex += 1
          this.list = (this.list || []).concat(data.list)
          this.options = data.params.top_search.option.list
          this.selectDefault(this.options)
          this.page.totalPage = data.page.page_count
          this.scrollLock = false
        })
    },
    goReport(id) {
      common.jump(`/reportDetail?d=${id}`, true)
    },
    searchByWord() {
      // 输入搜索关键字后搜索
      this.page.pageIndex = 1
      this.list = []
      this.getList()
    },
    selectDefault(l) {
      // 默认选中选项
      l.forEach((o) => {
        if (o.selected) {
          this.selected = o
          this.search.key = o.key
        }
      })
    },
    confirm() {
      // 回传
      const items = this.selectedItem

      this.$emit('getReport', items)
      this.close()
    },
    selectItem(l) {
      this.selectedItem = l
    },
    handleScroll() {
      const container = this.$refs.container
      container.addEventListener('scroll', () => {
        const scrolltop = container.scrollTop;
        const scrollheight = container.scrollHeight;
        const clientheight = container.clientHeight;

        if (scrolltop + clientheight >= scrollheight) {
          if (this.scrollLock) return
          this.getList()
        }
      }, false)
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    // this.getList()
    // this.handleScroll()
  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/global.less";

.mask {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 1111;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  .wrapper {
    .boxOuter;
    width: 880px;
    height: 550px;
    display: flex;
    flex-direction: column;
    .headline {
      height: 70px;
      padding: 0 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .filter {
        height: 70px;
        display: flex;
        align-items: center;
        .title {
          font-size: 24px;
          color: @dark;
          font-weight: bold;
        }
        .selectInputer {
          width: 300px;
          height: 40px;
          border-radius: 100px;
          background: rgba(185, 195, 195, 0.2);
          margin-left: 30px;
          padding: 0 20px;
          display: flex;
          align-items: center;
          .keyword {
            color: @sub;
            font-size: 14px;
            cursor: pointer;
            .selects {
              background-color: @dark;
              background-color: rgba(5, 15, 15, 0.8);
              position: absolute;
              width: 90px;
              border-radius: 4px;
              display: flex;
              flex-direction: column;
              padding: 10px 0;
              margin: 20px 0 0 -20px;
              .option {
                color: #fff;
                height: 30px;
                line-height: 30px;
                cursor: pointer;
                padding-left: 20px;
                &:hover {
                  background-color: @green;
                }
              }
            }
          }
          .direct {
            margin: 0 20px 0 10px;
            cursor: pointer;
          }
          .enter {
            flex: 1;
            color: @dark;
            font-size: 14px;
            background-color: transparent;
            &::placeholder {
              color: @dateColor;
              font-size: 14px;
            }
          }
          .search {
            margin-left: 10px;
            cursor: pointer;
          }
        }
      }
      .close {
        cursor: pointer;
      }
    }
    .container {
      flex: 1;
      overflow-y: auto;
      .content {
        padding: 0 30px;
        cursor: pointer;
        &:hover {
          background-color: rgba(185, 195, 195, 0.15);
        }
        .item {
          height: 120px;
          border-bottom: 1px solid #dcdcdc;
          display: flex;
          align-items: center;
          .img {
            width: 144px;
            height: 80px;
            border-radius: 4px;
            margin: 0 30px 0 20px;
            flex-shrink: 0;
            .pic {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .detail {
            overflow: hidden;
            flex: 1;
            height: 80px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            .title {
              height: 24px;
              line-height: 24px;
              font-size: 16px;
              color: @dark;
              overflow: hidden;
              text-overflow: ellipsis;
              font-weight: bold;
            }
            .text {
              font-size: 13px;
              color: @sub;
              height: 48px;
              line-height: 24px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
          .name {
            flex: 1;
            font-size: 16px;
            color: @dark;
          }
          .publiser {
            width: 188px;
            font-size: 14px;
            color: @dark;
            text-align: center;
          }
          .time {
            .numberFont;
            width: 130px;
            font-size: 14px;
            color: @dateColor;
            text-align: right;
          }
        }
      }
      .content:last-child {
        .item {
          border: none;
        }
      }
      .selected {
        background-color: rgba(65, 180, 140, 0.15) !important;
        span {
          color: @green !important;
        }
      }
    }
    .footline {
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 100px;
        background-color: @green;
        color: #fff;
        font-size: 14px;
        margin-right: 20px;
        cursor: pointer;
        &:active {
          .btnActive;
        }
        &:hover {
          .btnHover;
        }
      }
      .gray {
        margin-right: 0;
        background-color: @dateColor;
      }
    }
  }
}
</style>
